export default "__VITE_ASSET__DsRbQ39I__"